import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import { useAppSelector } from 'hooks/reduxHooks'
import { getPackageViewPricingPerNight } from 'lib/offer/getPackageViewPricingPerNightUtils'
import { OptimizelyExperiments, getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'

/**
 * Returns villas pricing from cheapest selected package option
 *  **CAN BE AFFECTED BY THE FOLLOWING EXPERIMENTS**
 *  - Experiment: cro_price_per_night
 * @returns [totalPrice, value, discount]
 */
function usePackageViewPrice(basePackageView: OfferPackageOptionView): [number, number, number] {
  const isPerNightPricingTestEnabled = !!useAppSelector((state: App.State) => getOptimizelyExperimentVariation(state, OptimizelyExperiments.pricePerNight))
  const packageView = isPerNightPricingTestEnabled ? getPackageViewPricingPerNight(basePackageView) : basePackageView

  const showValue = packageView.hotelValue > packageView.hotelTotal && packageView.package.shouldDisplayValue
  const showDiscountPill = packageView.hotelDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const value = showValue ? packageView.hotelValue : 0
  const discount = showDiscountPill ? packageView.hotelDiscountPercent : 0

  return [packageView.hotelTotal, value, discount]
}

export default usePackageViewPrice
